export default "__VITE_ASSET__CmlyhL0r__"